import React from 'react';
import axios from '../../../../axios-config.js';

const InputField = ({ title, value, onChange, placeholder, type = 'text' }) => {
  return (
    <label className="CreateCompanyInput modernField">
      <div className="input-title">{title}</div>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </label>
  );
};

class UserCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      isSubmitting: false,
      error: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const firstName = String(this.state.firstName || '').trim();
    const lastName = String(this.state.lastName || '').trim();
    const email = String(this.state.email || '').trim().toLowerCase();

    if (!firstName || !lastName || !email) {
      this.setState({ error: 'First name, last name, and email are required.' });
      return;
    }

    this.setState({ isSubmitting: true, error: '' });

    axios.post('/register/', {
      firstName,
      lastName,
      email,
    })
    .then(() => {
      if (typeof this.props.onCreated === 'function') {
        this.props.onCreated();
      }

      if (typeof this.props.back === 'function') {
        this.props.back();
      }
    })
    .catch((error) => {
      const message = error?.response?.data?.message || 'Failed to create user.';
      this.setState({ isSubmitting: false, error: message });
    });
  }

  render() {
    return (
      <div className="CompanyEditorModal">
        <div className="CompanyEditorHeader">
          <div className="CompanyEditorTitle">Create New User</div>
          <div className="CompanyEditorSubtitle">Create a user account that can be added to one or more companies.</div>
        </div>

        <div className="CompanyEditorSection">
          {this.state.error ? (
            <div className="PermissionLoadState error" style={{ marginBottom: '8px' }}>{this.state.error}</div>
          ) : null}

          <div className="CompanyEditorFormGrid">
            <InputField title="First Name" placeholder="John" value={this.state.firstName} onChange={(firstName) => this.setState({ firstName })} />
            <InputField title="Last Name" placeholder="Doe" value={this.state.lastName} onChange={(lastName) => this.setState({ lastName })} />
            <InputField title="Email" placeholder="jdoe@example.com" type="email" value={this.state.email} onChange={(email) => this.setState({ email })} />
          </div>

          <div className="CompanyEditorFormActions">
            <button type="button" className="CompanyEditorSecondaryButton" onClick={this.props.back}>Cancel</button>
            <button type="button" className="CompanyEditorPrimaryButton" disabled={this.state.isSubmitting} onClick={this.handleSubmit}>
              {this.state.isSubmitting ? 'Creating…' : 'Create User'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UserCreator;
